export var getPanelId = function getPanelId(id, index) {
  return "tab-panel-".concat(id, "-").concat(index);
};
export var getTabId = function getTabId(id, index) {
  return "tab-".concat(id, "-").concat(index);
};